import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import { originalTippyStyling } from './tippy-styles/original';

// tippyjs/react styled with default styling copied from the default CSS sheet.
export const TippyWithOriginalStyles = styled(Tippy)`
  ${originalTippyStyling}
  // OA: There shouldn't be a reason to inherit no-wrap from a parent, as that causes
  // the tooltip to be a one-liner with hidden overflow. So we enforce the default behavior
  // here.
  white-space: initial;
`;
